import React, { Component } from 'react';
import { Link } from 'redux-little-router';

import { routeMap } from 'router';

export default class Unconfirmed extends Component {
  render() {
    return (
      <div className="page_margin30">
        <p>Уважаемый пользователь!</p>
        <p>
          Вход с использованием учетной записи Госуслуг возможен только для пользователей, которые{' '}
          <b>подтвердили свою личность:</b>&nbsp;
          <br />- лично в{' '}
          <a href="https://map.gosuslugi.ru/map/co?filter=cfm">центре обслуживания</a>; <br />
          - онлайн в банках;
          <br />
          - с помощью электронной подписи.
          <br />
        </p>
        <p>
          Подробности можно прочитать{' '}
          <a href="https://www.gosuslugi.ru/help/faq/popular/2">здесь</a>
        </p>
        <p>
          Учетная запись Госуслуг, подтвержденная с помощью кода, полученного заказным письмом через
          Почту России, не подходит для авторизации в личном кабинете налогоплательщика.
        </p>
        <p>
          Если у Вас возникли сложности, Вы можете обратиться в{' '}
          <a href="https://www.gosuslugi.ru/help">службу поддержки портала Госуслуг</a>.
        </p>
        <p>
          Авторизоваться в сервисе можно также с помощью логина и пароля. Получить их Вы можете в
          любой налоговой инспекции, где принимают физических лиц.
        </p>
        <Link href={routeMap.login}>Вернуться к форме авторизации</Link>
      </div>
    );
  }
}
